



import Page from '../RMA/RMAOrder.vue'
export default {
  name: 'rmaOrderOEM',
  components: { Page },
}
